import icon from "assets/img/icons/special-offers.svg";

const CancelListingStartPrediction = ({ closeWindow, delistSubmit }) => {
  return (
    <>
      <header className="modal-window__header">
        <img src={icon} className="modal-window__icon" alt="" />
        <h5 className="modal-window__title">Craft Prediction</h5>
        <p className="modal-window__info">
          This card is listed for sale in the Marketplace. Using this card to
          craft an Prediction will delist it from the marketplace.
        </p>
      </header>
      <footer className="modal-window__footer">
        <button className="modal-window__footer-close" onClick={closeWindow}>
          Cancel
        </button>
        <button className="modal-window__footer-submit" onClick={delistSubmit}>
          Delist and Continue
        </button>
      </footer>
    </>
  );
};

export default CancelListingStartPrediction;
